import React, { useState } from "react";
import AuthGuard from "./components/AuthGuard";
import LessonCreateTab from "./components/LessonCreateTab";
import LessonListTab from "./components/LessonListTab";
import PromptCreateTab from "./components/PromptCreateTab";
import PromptListTab from "./components/PromptListTab";
import ResourceCreateTab from "./components/ResourceCreateTab";
import ResourceListTab from "./components/ResourceListTab";
import NewsCreateTab from "./components/NewsCreateTab";
import NewsListTab from "./components/NewsListTab";
import "./styles/global.css";
import "./App.css";

function App() {
  const [activeSection, setActiveSection] = useState("lessons"); // lessons, prompts, resources, news
  const [activeTab, setActiveTab] = useState("create"); // create, list

  return (
    <AuthGuard>
      <div className="App">
        <header className="app-header">
          <img src="/plane.png" alt="Practical AI" className="header-logo" />
          <h1>PRACTICAL AI CONTENT MANAGER</h1>
          <span className="header-version">v1.0.20260609094002</span>
        </header>

        {/* Main Navigation Menu */}
        <nav className="main-nav">
          <button
            className={`nav-button ${activeSection === "lessons" ? "active" : ""}`}
            onClick={() => {
              setActiveSection("lessons");
              setActiveTab("create");
            }}
          >
            📖 Lessons
          </button>
          <button
            className={`nav-button ${activeSection === "prompts" ? "active" : ""}`}
            onClick={() => {
              setActiveSection("prompts");
              setActiveTab("create");
            }}
          >
            💬 Prompts
          </button>
          <button
            className={`nav-button ${activeSection === "resources" ? "active" : ""}`}
            onClick={() => {
              setActiveSection("resources");
              setActiveTab("create");
            }}
          >
            🔗 Resources
          </button>
          <button
            className={`nav-button ${activeSection === "news" ? "active" : ""}`}
            onClick={() => {
              setActiveSection("news");
              setActiveTab("create");
            }}
          >
            📰 News
          </button>
        </nav>

        <main className="app-main">
          {/* Tab Navigation */}
          <div className="tab-nav">
            <button
              className={`tab-button ${activeTab === "create" ? "active" : ""}`}
              onClick={() => setActiveTab("create")}
            >
              ➕ Create
            </button>
            <button
              className={`tab-button ${activeTab === "list" ? "active" : ""}`}
              onClick={() => setActiveTab("list")}
            >
              📋 View All
            </button>
          </div>

          {/* Lessons Section */}
          {activeSection === "lessons" && (
            <>
              {activeTab === "create" ? (
                <LessonCreateTab />
              ) : (
                <LessonListTab />
              )}
            </>
          )}

          {/* Prompts Section */}
          {activeSection === "prompts" && (
            <>
              {activeTab === "create" ? (
                <PromptCreateTab />
              ) : (
                <PromptListTab />
              )}
            </>
          )}

          {/* Resources Section */}
          {activeSection === "resources" && (
            <>
              {activeTab === "create" ? (
                <ResourceCreateTab />
              ) : (
                <ResourceListTab />
              )}
            </>
          )}

          {/* News Section */}
          {activeSection === "news" && (
            <>
              {activeTab === "create" ? (
                <NewsCreateTab />
              ) : (
                <NewsListTab />
              )}
            </>
          )}
        </main>
      </div>
    </AuthGuard>
  );
}

export default App;
